
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/subsets",
      function () {
        return require("private-next-pages/customer-studio/subsets.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/subsets"])
      });
    }
  